import React, { useState } from 'react';

import CommonImage from '@/components/CommonImage';
import LoaderComponent from '@/components/LoaderComponent';
import ModalContainer from '@/components/modals/ModalContainer';

const EditCommentsTitleModal = ({ onClose, isLoading = false, defaultValue = '', onSave }) => {
	const [title, setTitle] = useState(defaultValue);

	const handleUpdate = () => {
		if (onSave) onSave(title);
		onClose();
	};

	return (
		<LoaderComponent loading={isLoading}>
			<ModalContainer className="update-sample-and-sales-modal">
				<div className="popup-wrapper width-420-modal shadow-8dp">
					<div className="common-popup update-sample-and-sales-modal">
						<div className="common-popup-header d-flex justify-content-between">
							<div className="popup-tilte">
								<h3 className="semibold-14 mb-0">Add Title</h3>
							</div>
							<div className="close-btn" onClick={onClose}>
								<CommonImage src="/icons/close.svg" alt="close" />
							</div>
						</div>
						<div className="common-popup-body">
							<div className="form-group mb-0">
								<label className="medium-14 gray_dark_01 mb-2">Title</label>
								<input
									placeholder="Edit title"
									type="text"
									className="form-control"
									value={title}
									onChange={(e) => setTitle(e.target.value)}
								/>
							</div>
						</div>
						<div className="modal-footer">
							<div className="footer-buttons text-right">
								<button className="button outline size32 ml-2" onClick={onClose}>
									Cancel
								</button>
								<button className="button size32 ml-2" onClick={handleUpdate}>
									Update
								</button>
							</div>
						</div>
					</div>
				</div>
			</ModalContainer>
		</LoaderComponent>
	);
};

export default EditCommentsTitleModal;
